import axios from 'axios';

const BASE_URL = 'https://backend.karizetemad.com/api/v1';

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 100000,
});

// Request interceptor - dil ve token header'ı ekle
api.interceptors.request.use((config) => {
    // Dil header'ı
    const language = localStorage.getItem('language') || 'fa';
    config.headers['Accept-Language'] = language;

    // Token header'ı - varsa ekle
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Response interceptor - 401 hatası durumunda login sayfasına yönlendir
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token geçersiz veya süresi dolmuş
            localStorage.removeItem('token');
            // Login sayfasına yönlendir (react router dışında çalışır)
            if (window.location.pathname !== '/auth') {
                window.location.href = '/auth';
            }
        }
        return Promise.reject(error);
    }
);

export const footerService = {
    getPhones: async () => {
        const response = await api.get('/management/phones/');
        return response.data;
    },

    getBranches: async () => {
        const response = await api.get('/management/branches/');
        return response.data;
    },

    getPlatforms: async () => {
        const response = await api.get('/management/platforms/');
        return response.data;
    },

    getAllFooterData: async () => {
        const [phones, branches, platforms] = await Promise.all([
            footerService.getPhones(),
            footerService.getBranches(),
            footerService.getPlatforms()
        ]);

        return { phones, branches, platforms };
    }
};

export const authService = {
    // OTP Register - Send
    registerOtpSend: async (phone, password) => {
        const response = await api.post('/authentication/otp/register/?action=send', {
            phone,
            password
        });
        return response.data;
    },

    // OTP Register - Verify
    registerOtpVerify: async (phone, otp) => {
        const response = await api.post('/authentication/otp/register/?action=verify', {
            phone,
            otp
        });
        if (response.data.access) {
            localStorage.setItem('token', response.data.access);
        }
        return response.data;
    },

    // OTP Login - Send
    loginOtpSend: async (phone) => {
        const response = await api.post('/authentication/otp/login/?action=send', {
            phone
        });
        return response.data;
    },

    // OTP Login - Verify
    loginOtpVerify: async (phone, otp) => {
        const response = await api.post('/authentication/otp/login/?action=verify', {
            phone,
            otp
        });
        if (response.data.access) {
            localStorage.setItem('token', response.data.access);
        }
        return response.data;
    },

    // Normal Login
    login: async (phone, password) => {
        const response = await api.post('/authentication/login/', {
            phone,
            password
        });
        if (response.data.access) {
            localStorage.setItem('token', response.data.access);
        }
        return response.data;
    },

    // Logout
    logout: () => {
        localStorage.removeItem('token');
    }
};

export const eventService = {
    getEventBySlug: async (slug) => {
        const response = await api.get(`/exhibition/events/${slug}/`);
        return response.data;
    },
    getEvents: async (offset = 0, limit = 20) => {
        const response = await api.get(`/exhibition/events/?offset=${offset}&limit=${limit}`);
        return response.data;
    },
    getEventForm: async (slug, type = '0') => {
        const response = await api.get(`/exhibition/events/${slug}/form/?type=${type}`);
        return response.data;
    },
    // YENİ: Form submit
    submitEventForm: async (slug, formData, type = '0') => {
        const response = await api.post(
            `/exhibition/events/${slug}/form/?type=${type}`,
            formData
            // headers belirtme - axios otomatik halleder
        );
        return response.data;
    },

    updateEventForm: async (slug, formData, type = '0') => {
        const response = await api.put(
            `/exhibition/events/${slug}/form/?type=${type}`,
            formData
        );
        return response.data;
    }
};

export const blogService = {
    getKeywords: async () => {
        const response = await api.get('/blog/keywords/');
        return response.data;
    },

    getPosts: async (limit = 6, offset = 0, antecedence = null) => {
        let url = `/blog/posts/?limit=${limit}&offset=${offset}`;
        if (antecedence !== null) {
            url += `&antecedence=${antecedence}`;
        }
        const response = await api.get(url);
        return response.data;
    },

    getPostBySlug: async (slug) => {
        const response = await api.get(`/blog/posts/${slug}/`);
        return response.data;
    }
};

export const managementService = {
    getSlides: async () => {
        const response = await api.get('/management/slides/');
        return response.data;
    },
    getIntroduction: async () => {
        const response = await api.get('/management/introduction/');
        return response.data;
    },
    getStandards: async () => {
        const response = await api.get('/management/standards/');
        return response.data;
    },
    getPartners: async () => {
        const response = await api.get('/management/partners/');
        return response.data;
    },
};

export const presentationService = {
    getServices: async () => {
        const response = await api.get('/presentation/services/');
        return response.data;
    },

     // Tek servis detayı
    getServiceBySlug: async (slug) => {
        const response = await api.get(`/presentation/services/${slug}/`);
        return response.data;
    },
    
    // Servis videoları
    getServiceVideos: async (slug, limit = 20, offset = 0) => {
        const response = await api.get(`/presentation/services/${slug}/videos/?limit=${limit}&offset=${offset}`);
        return response.data;
    },
    
    // Servis galerileri
    getServiceGalleries: async (slug, limit = 20, offset = 0) => {
        const response = await api.get(`/presentation/services/${slug}/galleries/?limit=${limit}&offset=${offset}`);
        return response.data;
    },
    
    // Galeri detayı
    getGalleryBySlug: async (serviceSlug, gallerySlug) => {
        const response = await api.get(`/presentation/services/${serviceSlug}/galleries/${gallerySlug}/`);
        return response.data;
    }
};


// ====================================================================
// Aşağıdaki messageService bloğunu mevcut services/api.js dosyanın
// sonuna (örn. presentationService'den sonra) ekle.
// `api` instance'ı zaten dosyanın en üstünde tanımlı, tekrar oluşturma.
// ====================================================================

export const messageService = {
    // Mesaj listesi - opsiyonel event slug ve search filtresi
    getMessages: async ({ eventSlug, search } = {}) => {
        const params = new URLSearchParams();
        if (eventSlug) params.append('event__slug', eventSlug);
        if (search) params.append('search', search);

        const query = params.toString();
        const response = await api.get(`exhibition/messages/${query ? `?${query}` : ''}`);
        return response.data;
    },

    // Tek mesaj + reply thread
    getMessageReplies: async (id) => {
        const response = await api.get(`exhibition/messages/${id}/replies/`);
        return response.data;
    },

    // Yeni mesaj oluştur (multipart/form-data)
    // payload: { event?: slug, title, text, attachment? : File }
    createMessage: async ({ event, title, text, attachment }) => {
        const formData = new FormData();
        if (event) formData.append('event', event);
        formData.append('title', title);
        formData.append('text', text);
        if (attachment) formData.append('attachment', attachment);

        const response = await api.post('exhibition/messages/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    // Mesaja cevap gönder (multipart/form-data)
    // payload: { text, attachment? : File }
    replyToMessage: async (id, { text, attachment }) => {
        const formData = new FormData();
        formData.append('text', text);
        if (attachment) formData.append('attachment', attachment);

        const response = await api.post(`exhibition/messages/${id}/replies/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
};

// Yeni mesaj formundaki "رویداد" dropdown'u için: kullanıcının
// başvurduğu / submit ettiği etkinliklerin slug listesini döner.
export const eventOptionsService = {
    getSubmittedEventSlugs: async () => {
        const response = await api.get('/exhibition/events/?submitted=true');
        return response.data; // [{ slug: '...' }, ...]
    }
};


// ====================================================================
// Aşağıdaki profileService bloğunu mevcut services/api.js dosyanın
// sonuna ekle. `api` instance'ı zaten dosyada mevcut.
// ====================================================================

export const profileService = {
    // Profil bilgilerini getir (picture, natural, legal)
    getProfile: async () => {
        const response = await api.get('/profile/');
        return response.data;
    },

    // Avatar yükle (multipart/form-data)
    uploadPicture: async (file) => {
        const formData = new FormData();
        formData.append('picture', file);
        const response = await api.patch('/profile/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    // Avatar sil (JSON ile picture: null)
    deletePicture: async () => {
        const response = await api.patch('/profile/', { picture: null });
        return response.data;
    },

    // Gerçek kişi bilgilerini güncelle
    // Boş alanlar gönderilebilir, zorunlu değil
    updateNatural: async ({ name, identification, phone, email, province, gender }) => {
        const body = {};
        if (name !== undefined) body.name = name;
        if (identification !== undefined) body.identification = identification;
        if (phone !== undefined) body.phone = phone;
        if (email !== undefined) body.email = email;
        if (province !== undefined) body.province = province; // slug string
        if (gender !== undefined) body.gender = gender;       // 0 | 1
        const response = await api.put('/profile/natural/', body);
        return response.data;
    },

    // Tüzel kişi bilgilerini güncelle
    // Boş alanlar gönderilebilir, zorunlu değil
    updateLegal: async ({
        name, phone, identification, ceo_name, contact_name,
        contact_phone, province, scope, knowledge_enterprise, website
    }) => {
        const body = {};
        if (name !== undefined) body.name = name;
        if (phone !== undefined) body.phone = phone;
        if (identification !== undefined) body.identification = identification;
        if (ceo_name !== undefined) body.ceo_name = ceo_name;
        if (contact_name !== undefined) body.contact_name = contact_name;
        if (contact_phone !== undefined) body.contact_phone = contact_phone;
        if (province !== undefined) body.province = province;                   // slug string
        if (scope !== undefined) body.scope = scope;                            // slug string
        if (knowledge_enterprise !== undefined) body.knowledge_enterprise = knowledge_enterprise; // boolean
        if (website !== undefined) body.website = website;
        const response = await api.put('/profile/legal/', body);
        return response.data;
    },

    // İl (province) listesi
    getProvinces: async () => {
        const response = await api.get('/profile/provinces/');
        return response.data; // [{ name, slug }, ...]
    },

    // Faaliyet alanı (scope) listesi - sadece legal için
    getScopes: async () => {
        const response = await api.get('/profile/scopes/');
        return response.data; // [{ name, slug }, ...]
    }
};


// ====================================================================
// Aşağıdaki financeService bloğunu mevcut services/api.js dosyanın
// sonuna ekle. `api` instance'ı zaten dosyada mevcut.
// ====================================================================

export const financeService = {
    // Kullanıcının tüm ödeme kayıtlarının listesi
    getPayments: async () => {
        const response = await api.get('/finance/payments/');
        return response.data; // [{ code, type, paid, status, amount, ... }, ...]
    },

    // ── چک‌های ضمانت (type=2) ──
    // Belirli bir ödeme koduna ait çek listesini getir
    getChecks: async (code) => {
        const response = await api.get(`/finance/payments/${code}/checks/`);
        return response.data; // [{ number, issued_at, amount, bank, image }, ...]
    },

    // Çek listesini oluştur / tamamen değiştir (mevcut çekler silinir)
    // multipart/form-data ile checks[0][number], checks[0][image] ... şeklinde indeksli gönderilir
    // (resim dosyası içerdiği için JSON değil, form-data kullanılır)
    // checks: [{ number, issued_at, amount, bank, image?: File|null }, ...]
    replaceChecks: async (code, checks) => {
        const formData = new FormData();
        checks.forEach((check, index) => {
            formData.append(`checks[${index}][number]`, check.number);
            formData.append(`checks[${index}][issued_at]`, check.issued_at);
            formData.append(`checks[${index}][amount]`, check.amount ?? '');
            formData.append(`checks[${index}][bank]`, check.bank);
            if (check.image) {
                formData.append(`checks[${index}][image]`, check.image);
            }
        });

        const response = await api.post(`/finance/payments/${code}/checks/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    // ── سند پرداخت (type=1 پیش‌پرداخت / type=3 پرداخت‌نهایی) ──
    // Belirli bir ödeme koduna ait dekont/sendi getir
    getDocument: async (code) => {
        const response = await api.get(`/finance/payments/${code}/document/`);
        return response.data; // { code, bank, amount, iban, transfered_at, receipt }
    },

    // Dekont oluştur / değiştir (multipart/form-data - dosya içerir)
    // payload: { code, bank, amount, iban, transfered_at, receipt?: File }
    submitDocument: async (paymentCode, { code, bank, amount, iban, transfered_at, receipt }) => {
        const formData = new FormData();
        formData.append('code', code);
        formData.append('bank', bank);
        formData.append('amount', amount);
        formData.append('iban', iban);
        formData.append('transfered_at', transfered_at);
        if (receipt) formData.append('receipt', receipt);

        const response = await api.post(`/finance/payments/${paymentCode}/document/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    getInvoice: async (code) => {
        const response = await api.get(`/finance/payments/${code}/invoice/`);
        return response.data;
    }
};